import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {Box, Card, CardHeader, IconButton, Typography} from '@mui/material';
import {ExamModule, UserModule} from '@cp/model';

interface ModuleSettingsCardProps {
  userModule: UserModule;
  fullModule: ExamModule;
  handleViewModule: (module: ExamModule, userModule: UserModule) => void;
  handleDeleteModule: (module: ExamModule, userModule: UserModule) => void;
}

export default function ModuleSettingsCard({
  userModule,
  fullModule,
  handleViewModule,
  handleDeleteModule,
}: ModuleSettingsCardProps) {
  return (
    <Card
      key={userModule.moduleId}
      sx={{'&:hover': {boxShadow: 3}}}
      data-testid="module-settings-card"
      data-module-id={userModule.moduleId}
    >
      <CardHeader
        title={
          <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
            <Typography variant="h6" data-testid="module-name">
              {fullModule?.name || 'Unknown Module'}
            </Typography>
            <Box sx={{display: 'flex', gap: 1}}>
              <IconButton
                size="small"
                onClick={() => handleViewModule(fullModule!, userModule)}
                sx={{color: 'primary.main'}}
                title="View and edit topics"
                data-testid="view-module-button"
              >
                <VisibilityIcon />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => handleDeleteModule(fullModule!, userModule)}
                sx={{color: 'error.main'}}
                title="Remove module"
                data-testid="delete-module-button"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </Box>
        }
        subheader={
          <Box sx={{mt: 1}}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {fullModule?.level} • {fullModule?.subject}
              {fullModule?.examBoard && ` • ${fullModule.examBoard}`}
              {` • ${userModule.topics?.length} of ${fullModule?.topics?.length} topics`}
            </Typography>
          </Box>
        }
      />
    </Card>
  );
}
